<template>
    <div v-if="hasImage" class="image-segment">
        <image-display :image="image" :controls="segmentData.controls" />
        <p class="image-segment__caption" v-if="image.show_caption">{{ image.caption }}</p>
    </div>
</template>

<script>
import ImageDisplay from "~/components/handbook/ImageDisplay";

export default {
    components: { ImageDisplay },

    props: {
        id: String,
        captionId: String,
        segmentData: Object,
        imageProp: "",
    },

    data: function () {
        return {
            image: this.segmentData.image ?? {
                path: this.segmentData.content ?? null,
                show_caption: this.segmentData.caption ?? false,
                caption: this.segmentData.extra ?? null,
            },
            type: "image",
            name: "Image",
            defaultImage: "https://assets.procreate.art/community/default/default-cover.jpg",
        };
    },

    computed: {
        hasImage() {
            return !!this.image.path;
        },
    },
};
</script>
